import React from 'react'
import { approved, denied, waiting } from '../../../Templates/icons'
export const renderActionIcon = (authorized, cb) => {
    if (authorized === 1) {
        return approved(cb)
    } else if (authorized === -1) {
        return denied(cb)
    } else {
        return waiting(cb)
    }
}

export const renderAuthorizationOptions = (cb) => {
    return <div className="flex">
        <div>Set New Authorization Status: </div>
        {approved(cb)}
        {waiting(cb)}
        {denied(cb)}
    </div>
}